import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';

import { makeImagePreviewable } from '../utils';

const Image = ({ content, style, objectFit }) => {
  const image = makeImagePreviewable(content);

  if (!image.localFile) {
    return <p>missing</p>;
  }

  return image.localFile.childImageSharp?.gatsbyImageData ? (
    <GatsbyImage
      alt={image.alt || ''}
      image={image.localFile.childImageSharp.gatsbyImageData}
      style={style}
      objectFit={objectFit}
    />
  ) : (
    <img src={image.localFile.url} alt={image.alt} style={style} />
  );
};

Image.defaultProps = {
  style: {},
  objectFit: 'cover',
};

Image.propTypes = {
  content: PropTypes.shape({
    localFile: PropTypes.shape({
      extension: PropTypes.string,
      url: PropTypes.string,
      childImageSharp: PropTypes.shape({
        gatsbyImageData: PropTypes.shape({}),
      }),
    }),
    alt: PropTypes.string,
  }).isRequired,
  style: PropTypes.shape({}),
  objectFit: PropTypes.string,
};

export default Image;
